import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3mpqvcxzwd: FaireBrandEntity = {
  token: "b_3mpqvcxzwd",
  type: "brand",
  name: "LadyJuneAccessories",
  avatarUrl:
    "https://cdn.faire.com/fastly/0916e618b716cc4a0db22bfbd3fcc82ebb8627e9d7bf484036f6e389698c2405.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8968ec6728aef3dddb7cbc2b20059e3831320dd398793ead689802aa12448d34.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0916e618b716cc4a0db22bfbd3fcc82ebb8627e9d7bf484036f6e389698c2405.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8968ec6728aef3dddb7cbc2b20059e3831320dd398793ead689802aa12448d34.jpeg",
  location: "Montreal, QC, CAN",
  minimumOrderDollars: 79,
  rating: 4.9,
  reviewCount: 39,
  isTopShop: true,
  isInsider: false,
  description:
    "We sell minimalist style accessories that you can wear every day. We love the accessories design with wood, leather, metal, crystal elements. We hope our products can inspire your day to day look and your mood !  \nHappy Shopping ! ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:24.983Z",
    importedBy: "entity-db-cli",
  },
};
